import _get from 'lodash/get';

export const parseFulfillmentDetails = (response) => {
  const uploadableDocsList = (
    response?.kycResponse?.documentTypes || []
  ).filter((d) => d.documentAction === 'UPLOAD');
  const inputDocsList = (response?.kycResponse?.documentTypes || []).filter(
    (d) => d.documentAction !== 'UPLOAD'
  );
  return {
    kycStatus: _get(response, 'kycResponse.kycStatus'),
    viewFields: [
      {
        label: 'Fastag Serial Number',
        value: _get(response, 'fastagOrderDetailContent.serialNumber'),
      },
      {
        label: 'Customer Name',
        value: _get(response, 'userResponse.username'),
      },
      {
        label: 'Customer Mobile No',
        value: _get(response, 'userResponse.phone'),
      },
      ...inputDocsList.map(({ label, documentNumber }) => ({
        label,
        value: documentNumber,
      })),
    ],
    documents: uploadableDocsList,
  };
};
